

export let detailsField = () => {

    // function generateSalarySlipYears(startYear: number) {
    //     const currentYear = new Date().getFullYear();
    //     const salarySlipYear = [];

    //     for (let year = startYear; year <= currentYear + 1; year++) {
    //         salarySlipYear.push({ name: `${year}`, value: year });
    //     }

    //     return salarySlipYear
    // }

    // const startYear = 2022;

    // const salarySlipYear = generateSalarySlipYears(startYear)
    // salarySlipYear.sort((a: any, b: any) => b.value - a.value)

    const salarySlipMonth = [
        { name: 'January', value: 1 },
        { name: 'February', value: 2 },
        { name: 'March', value: 3 },
        { name: 'April', value: 4 },
        { name: 'May', value: 5 },
        { name: 'June', value: 6 },
        { name: 'July', value: 7 },
        { name: 'August', value: 8 },
        { name: 'September', value: 9 },
        { name: 'October', value: 10 },
        { name: 'November', value: 11 },
        { name: 'December', value: 12 },
    ]


    const personalDetailsFields: any[] = [
        { label: 'Employee Id', type: "text", name: "employee_id", isEnable: false },
        { label: 'Name', type: "text", name: "name", isEnable: false },
        { label: 'Fathers Name', type: "text", name: "Fathers_Name", isEnable: false },
        { label: 'DOB', type: "date", name: "DOB", isEnable: false },
        { label: 'Emergency Contact No', type: "number", name: "contact_no", isEnable: false },
        { label: 'Alternative Phone Number', type: "number", name: "alternativePhoneNumber", isEnable: true },
        { label: 'Blood Group', type: "text", name: "blood_group", isEnable: false },
        { label: 'Personal Email', type: "email", name: "personalEmail", isEnable: false },
        { label: 'Official Email', type: "email", name: "officialEmail", isEnable: false }
    ]

    const permanentAddressField = [
        { label: "Street", type: "text", name: "permanentStreet", isEnable: true },
        { label: "City", type: "text", name: "permanentCity", isEnable: true },
        { label: "State", type: "text", name: "permanentState", isEnable: true },
        { label: "Country", type: "text", name: "permanentCountry", isEnable: true },
        { label: "Pincode", type: "text", name: "permanentPincode", isEnable: true }
    ]
    const residentialAddressField = [
        { label: "Street", type: "text", name: "residentialStreet", isEnable: true },
        { label: "City", type: "text", name: "residentialCity", isEnable: true },
        { label: "State", type: "text", name: "residentialState", isEnable: true },
        { label: "Country", type: "text", name: "residentialCountry", isEnable: true },
        { label: "Pincode", type: "text", name: "residentialPincode", isEnable: true }
    ]

    const professionalDetailsField = [
        { label: "Job Role", type: "text", name: "jobRole", isEnable: true },
        { label: "Educational Qualification", type: "text", name: "educationalQualification", isEnable: true },
        { label: "Technology Stack", type: "text", name: "technologyStack", isEnable: true },
        { label: "Years of Experience", type: "text", name: "yearsOfExperience", isEnable: true },
        { label: "Last Organization", type: "text", name: "lastOrganizationWorked", isEnable: true },
        { label: "Employee Tag", type: "text", name: "employeeTag", isEnable: true }
    ]

    const identityDetailsField = [
        { label: "Aadhar Number", type: "text", name: "aadharNumber", isEnable: true },
        { label: "PAN Number", type: "text", name: "panNumber", isEnable: true }
    ]

    const bankDetailsField = [
        { label: "Bank Name", type: "text", name: "bankName", isEnable: true },
        { label: "Account Number", type: "text", name: "accountNumber", isEnable: true },
        { label: "IFSC Code", type: "text", name: "ifscCode", isEnable: true },
        { label: "UAN", type: "text", name: "uan", isEnable: true },
        { label: "ESIC No", type: "text", name: "esicNo", isEnable: true }
    ]

    const employeeDetailsField = [
        { label: 'Date Of Joining', type: "date", name: "date_of_joining", isEnable: false },
        { label: 'Designation', type: "text", name: 'designation', isEnable: false },
        { label: 'Employee Id', type: "text", name: 'employee_id', isEnable: false },
        { label: 'Employee Type', type: "text", name: 'employee_type', isEnable: false },
        {
            label: 'Employee Role', type: "select", name: 'roles', isEnable: false,
            options: [
                { value: "ADMIN", label: 'Admin' },
                { value: "USER", label: 'User' },
                { value: "COREMEMBERS", label: 'Core Members' },
            ]
        },
        { label: 'Agenda', type: "checkbox", name: 'agendaRequired', isEnable: false },
        { label: 'Work Update', type: "checkbox", name: 'workupdateRequired', isEnable: false },
        { label: 'Official Email', type: "email", name: 'officialEmail', isEnable: false }
    ]


    const newEmployeeDetails = [
        { name: "name", type: "text", label: "Name", required: true },
        { name: "personalEmail", type: "email", label: "Personal Email", required: true },
        { name: "officialEmail", type: "email", label: "Official Email", required: true },
        { name: "designation", type: "text", label: "Designation", required: true },
        { name: "contact_no", type: "number", label: "Contact Number", required: true },
        { name: "blood_group", type: "text", label: "Blood Group", required: true },
        { name: "DOB", type: "date", label: "Date of Birth", required: false },
        { name: "grossSalary", type: "number", label: "Gross Salary", required: true },
        { name: "jobRole", type: "text", label: "Job Role", required: false },
        { name: "educationalQualification", type: "text", label: "Educational Qualification", required: false },
        { name: "technologyStack", type: "text", label: "Technology Stack", required: false },
        { name: "yearsOfExperience", type: "number", label: "Years of Experience", required: false },
        { name: "lastOrganizationWorked", type: "text", label: "Last Organization", required: false },
        {
            name: "employeeTag", type: "select", label: "Employee Tag", required: false,
            options: [
                { value: 'Star', label: 'Star' },
                { value: 'Engineer', label: 'Engineer' },
                { value: 'Operator', label: 'Operator' },
            ]
        },
        { name: "aadharNumber", type: "text", label: "Aadhar Number", required: false },
        { name: "panNumber", type: "text", label: "PAN Number", required: false },
        { name: "permanentStreet", type: "text", label: "Permanent Street", required: false },
        { name: "permanentCity", type: "text", label: "Permanent City", required: false },
        { name: "permanentState", type: "text", label: "Permanent State", required: false },
        { name: "permanentPincode", type: "number", label: "Permanent Pincode", required: false },
        { name: "permanentCountry", type: "text", label: "Permanent Country", required: false },
        { name: "residentialStreet", type: "text", label: "Residential Street", required: false },
        { name: "residentialCity", type: "text", label: "Residential City", required: false },
        { name: "residentialState", type: "text", label: "Residential State", required: false },
        { name: "residentialPincode", type: "number", label: "Residential Pincode", required: false },
        { name: "residentialCountry", type: "text", label: "Residential Country", required: false },
        { name: "alternativePhoneNumber", type: "number", label: "Alternative Phone Number", required: false },
        { name: "bankName", type: "text", label: "Bank Name", required: false },
        { name: "accountNumber", type: "text", label: "Account Number", required: false },
        { name: "ifscCode", type: "text", label: "IFSC Code", required: false },
        { name: "uan", type: "text", label: "UAN", required: false },
        { name: "esicNo", type: "text", label: "ESIC No", required: false },
        {
            name: "employeeType", type: "select", label: "Employee Type", required: true,
            options: [
                { value: 'Full Time', label: 'Full Time' },
                { value: 'Part Time', label: 'Part Time' },
                { value: 'Intern', label: 'Intern' },
            ]
        },
        {
            name: "roles", type: "select", label: "Role", required: true,
            options: [
                { value: 'ADMIN', label: 'Admin' },
                { value: 'USER', label: 'User' },
                { value: "COREMEMBERS", label: 'Core Members' },
            ]
        },
        { name: "agendaRequired", type: "checkbox", label: "Agenda Required", required: false },
        { name: "workupdateRequired", type: "checkbox", label: "Work Update Required", required: false },
    ]

    const newProjectdetails = [
        { name: 'projectName', type: "text", label: "Project Name", id: 1 },
        { name: 'teamName', type: "text", label: "Team Name", id: 2 },
        { name: 'projectClient', type: 'text', label: 'Client Name', id: 3 },
        { name: 'projectDetails', type: 'text', label: 'Details', id: 4 },
        { name: 'projectDemoDate', type: 'date', label: 'Demo', id: 5 },
        { name: 'projectWorkingStatus', type: 'text', label: 'Status', id: 6 },
        { name: 'projectStartDate', type: 'date', label: 'Start Date', id: 7 },
        { name: 'projectDeliveryDate', type: 'date', label: 'End Date', id: 8 },
        { name: 'projectLead', type: 'select', label: 'Project Leader', id: 9 },
        { name: 'projectFrontEndMembers', type: 'select', label: 'Frontend Member', id: 10 },
        { name: 'projectBackEndMembers', type: 'select', label: 'Backend Member', id: 11 },
        { name: 'teamMembers', type: 'select', label: 'Team Member', id: 12 },
        { name: 'projectRemark', type: 'text', label: 'Remarks', id: 13 }
    ]

    const field = [
        { label: 'ProvidentFund' },
        { label: 'EmployeesStateInsurance' },
        { label: 'OverTime' },
    ]
    const salaryCalculation = [
        'BasicSalary',
        'DearnessAllowance',
        'HouseRentAllowance',
        'SpecialAllowance',
        'NetSalary'
    ]
    const createLeave = [
        { name: 'casual', type: 'number', label: 'Casual Leave' },
        { name: 'special', type: 'number', label: 'Special Leave' },
        { name: 'medical', type: 'number', label: 'Medical Leave' },
    ]

    const createHoliday = [
        { name: 'date', type: 'date', label: 'Date' },
        { name: 'reason', type: 'text', label: 'Holiday Description' }
    ]

    const createWFH = [
        { name: 'fromDate', type: 'date', label: 'From Date' },
        { name: 'toDate', type: 'date', label: 'To Date' },
        { name: 'noOfDays', type: 'number', label: 'No of Days' },
        { name: 'reasonForWFH', type: 'text', label: 'Reason' },
    ]
    const dateRangeField = [
        { name: 'startDate', label: 'Form Date', type: 'date' },
        { name: 'endDate', label: 'To Date', type: 'date' }
    ]




    return { personalDetailsFields, permanentAddressField, residentialAddressField, professionalDetailsField, identityDetailsField, bankDetailsField, employeeDetailsField, newEmployeeDetails, field, salaryCalculation, salarySlipMonth, newProjectdetails, createLeave, createWFH, dateRangeField, createHoliday };




}


